import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import Select from 'react-select'
import StandardPerformanceTable from 'wt-react/dist/components/StandardPerformance/StandardPerformanceTable.js'
import DetailsTable from 'wt-react/dist/components/StandardPerformance/DetailsTable.js'
import { getFundUrl } from 'wt-react/dist/util/functions.js'
import { loadData, updateWeights, setSelectedFundSide } from '../../actions/data'
import ReactTooltip from 'react-tooltip'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { getData, getFundData, getYTW, getDuration, getYTWVS, getDurationVS, getWeights, getSelectedFund, getFilteredFundData, getLeftFund, getRightFund } from '../../reducers/data'
import './App.css'

library.add(faQuestionCircle, faCircleNotch)

const WT_FUND_DETAILS = {
  AGGY: {
    title: 'WisdomTree Yield Enhanced U.S. Aggregate Bond Fund (AGGY)',
    index: 'Bloomberg U.S. Aggregate Enhanced Yield Index',
    tooltip: 'Bloomberg U.S. Aggregate Enhanced Yield Index: a constrained, rules-based approach that reweights the sector, maturity, and credit quality of the Bloomberg U.S. Aggregate Index across various sub-components in order to enhance yield.'
  },
  USFR: {
    title: 'WisdomTree Floating Rate Treasury Fund (USFR)',
    index: 'Bloomberg U.S. Treasury Floating Rate Bond Index',
    tooltip: 'Bloomberg U.S. Treasury Floating Rate Bond Index: A rules-based, market-capitalization-weighted index engineered to measure the performance of floating rate U.S. Treasury notes.',
    pdfLink: '/-/media/us-media-files/documents/resource-library/investment-case/the-case-for-floating-rate-treasury-fund-(usfr).pdf'
  },
  AGZD: {
    title: 'WisdomTree Interest Rate Hedged U.S. Aggregate Bond Fund (AGZD)',
    index: 'Bloomberg Rate Hedged U.S. Aggregate Bond Index',
    tooltip: 'Bloomberg Rate Hedged U.S. Aggregate Bond Index: a rate hedge solution which offers a ‘long portfolio’ that is representative of the fixed income benchmark, the Bloomberg U.S. Aggregate Index (Agg), while overlaying a short position in Treasury futures to target a zero duration.',
    pdfLink: '/-/media/us-media-files/documents/resource-library/investment-case/the-case-for-agzd.pdf'
  },
  HYZD: {
    title: 'WisdomTree Interest Rate Hedged High Yield Bond Fund (HYZD)',
    index: 'WisdomTree U.S. High Yield Corporate Bond, Zero Duration Index',
    tooltip: 'WisdomTree U.S. High Yield Corporate Bond, Zero Duration Index: a rate hedge solution that employs a quality screen to identify high yield bonds with favorable fundamental characteristics and then tilts to those which offer more attractive income potential, while overlaying a short position in Treasury futures to target a zero duration.',
    pdfLink: '/-/media/us-media-files/documents/resource-library/investment-case/the-case-for-hyzd.pdf'
  }
}

const RIGHT_SIDE_TICKERS = ['HYZD', 'USFR', 'AGZD']

class App extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showTab: 'overview',
      screenWidth: null
    }
    this.handleChangeTable = this.handleChangeTable.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
  }

  handleChangeTable(type) {
    this.setState({
      showTab: type
    })
  }

  componentDidMount() {
    this.props.loadData()
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions() {
    this.setState({ screenWidth: window.innerWidth })
  }

  updateWgts(value) {
    this.props.updateWeights(value)
  }

  selectedFundClass(value) {
    return value === this.props.selectedFund ? 'button-selected' : ''
  }

  updateFund(value) {
    this.props.updateFund(value)
  }

  getAsOf(value) {
    return new Date(value).toLocaleString().split(',')[0].split(' ')[0]
  }

  renderFundOverview(fund) {
    const details = WT_FUND_DETAILS[fund.ticker]

    // IF WT details are found then render special box
    if (details) {
      return (
        <div className='info'>
          <div className='info-title'>{`${fund.name} (${fund.ticker})`}</div>
          <div className='info-description'>
            Seeks to track the price and yield performance, before fees and expenses, of the&nbsp;
            <span data-tip data-for={`${fund.ticker}-info`} className='info-tooltip'>
              <strong>{details.index}</strong>
            </span>
            <ReactTooltip id={`${fund.ticker}-info`} type='light' className='deftooltip' effect='float'>
              <div>{details.tooltip}</div>
            </ReactTooltip>
          </div>
          <a className='info-link' href={fund.fundPageURL} target='_blank' rel='noopener noreferrer'>
            Learn more about {fund.ticker}
          </a>
          {/* { details.pdfLink ? 
        <p style={{ textAlign: 'left', marginTop: '15px' }}>
          <a className="pdf-link" href={details.pdfLink}>
            <strong>The Case For {fund.ticker}</strong>
          </a>
        </p>
        : null } */}
        </div>
      )
    } else {
      // Render overview for all other funds
      return (
        <div className='info'>
          <div className='info-title'>{`${fund.name} (${fund.ticker})`}</div>
          <a className='info-link' href={fund.fundPageURL ? fund.fundPageURL : getFundUrl(fund)} target='_blank' rel='noopener noreferrer'>
            Learn more about {fund.ticker}
          </a>
        </div>
      )
    }
  }

  renderShowOverview() {
    const { leftFund, rightFund } = this.props

    return (
      <div className='info-box'>
        {this.renderFundOverview(leftFund)}
        {this.renderFundOverview(rightFund)}
      </div>
    )
  }

  renderPerformanceTable() {
    const { leftFund, rightFund } = this.props

    return <StandardPerformanceTable data={[leftFund, rightFund]} showTitle={false} showCommonPeriod={true} commonPeriodStart={leftFund ? leftFund.stdPerformance[0].commonPeriodNAVStart : null} commonPeriodEnd={leftFund ? leftFund.stdPerformance[0].commonPeriodNAVEnd : null} isPortfolio={false} showSinceInception={false} showPerfFootnote={true} hideCumulativeReturns={true} wtFundsOnly={true} sidePadding={60} />
  }

  renderDetailsTable() {
    const { leftFund, rightFund } = this.props

    return <DetailsTable data={[leftFund, rightFund]} showTitle={false} showCommonPeriod={false} isPortfolio={false} showPerfFootnote={true} sidePadding={60} />
  }

  getSecYield(fund) {
    if (fund.stdPerformance[0].sec30DayYieldUnSub) {
      return `${(fund.stdPerformance[0].sec30DayYieldUnSub * 100).toFixed(2)}%`
    } else {
      return '-'
    }
  }

  getSecYieldAsOfDate(fund) {
    return this.getAsOf(fund.stdPerformance[0].asOfDate)
  }

  render() {
    const { weights, ytw, duration, ytwVS, durationVS, fundData, setSelectedFundSide, leftFund, rightFund } = this.props

    const { showTab, screenWidth } = this.state

    const railStyle = {
      backgroundColor: '#F4F4F5',
      height: '20px'
    }
    const trackStyle = {
      backgroundColor: '#F4F4F5',
      height: '20px'
    }
    const handleStyle = {
      marginTop: '-10px',
      height: '40px',
      width: '40px',
      border: '2px solid #050139'
    }

    if (screenWidth && screenWidth <= 767) {
      railStyle.height = '10px'
      trackStyle.height = '10px'
      handleStyle.height = '28px'
      handleStyle.width = '28px'
    }

    // Set up the styles for the React Select dropdowns
    const customSelectStyles = {
      menu: (provided, state) => ({
        ...provided,
        borderRadius: 0,
        borderColor: '#050139'
      }),

      option: (provided, state) => ({
        ...provided,
        cursor: 'pointer',
        borderRadius: 0,
        backgroundColor: state.isSelected ? '#050139' : 'white',
        '&:hover': {
          backgroundColor: '#050139',
          color: 'white'
        }
      }),

      control: (provided, state) => ({
        ...provided,
        borderRadius: 0,
        cursor: 'pointer',
        backgroundColor: 'white',
        boxShadow: 'none',
        borderColor: '#050139',
        '&:hover': {
          borderColor: '#050139'
        }
      })
    }

    // Render content when we have a left and right fund
    let barbellOutput
    if (leftFund && rightFund) {
      let infoTables
      switch (showTab) {
        case 'performance':
          infoTables = this.renderPerformanceTable()
          break
        case 'details':
          infoTables = this.renderDetailsTable()
          break
        default:
          infoTables = this.renderShowOverview()
      }

      const selectOptionsLeft = fundData
        .filter(fund => fund.ticker !== rightFund.ticker && !RIGHT_SIDE_TICKERS.includes(fund.ticker))
        .map(fund => {
          return {
            value: fund.ticker,
            label: `${fund.ticker} - ${fund.name}`
          }
        })

      const selectOptionsRight = fundData
        .filter(fund => fund.ticker !== leftFund.ticker && RIGHT_SIDE_TICKERS.includes(fund.ticker))
        .map(fund => {
          return {
            value: fund.ticker,
            label: `${fund.ticker} - ${fund.name}`
          }
        })

      barbellOutput = (
        <div className='fibarbell'>
          <div className='fund-select'>
            <div className='select-dropdown'>
              <Select
                options={selectOptionsLeft}
                isClearable={false}
                placeholder='LOADING...'
                styles={customSelectStyles}
                onChange={selectedItem => (selectedItem ? setSelectedFundSide('left', selectedItem.value) : null)}
                value={
                  leftFund
                    ? {
                        value: leftFund.ticker,
                        label: `${leftFund.ticker} - ${leftFund.name}`
                      }
                    : null
                }
              />
            </div>
            <div className='select-dropdown'>
              <Select
                options={selectOptionsRight}
                isClearable={false}
                placeholder='LOADING...'
                styles={customSelectStyles}
                onChange={selectedItem => (selectedItem ? setSelectedFundSide('right', selectedItem.value) : null)}
                value={
                  rightFund
                    ? {
                        value: rightFund.ticker,
                        label: `${rightFund.ticker} - ${rightFund.name}`
                      }
                    : null
                }
              />
            </div>
          </div>

          <div className='barbell'>
            <div className='octagon wgt-left'>
              <div className='inner'>
                <div className='wgt-barbell wgt-leftfl'>
                  <div className='ticker'>{leftFund.ticker}</div>
                  <div className='wgt'>{weights[0]}%</div>
                </div>
              </div>
            </div>
            <div className='octagon wgt-right'>
              <div className='inner'>
                <div className='wgt-barbell wgt-rightfl'>
                  <div className='ticker'>{rightFund.ticker}</div>
                  <div className='wgt'>{weights[1]}%</div>
                </div>
              </div>
            </div>

            <div className='bar'>
              <Slider railStyle={railStyle} trackStyle={trackStyle} handleStyle={handleStyle} min={0} max={100} step={10} defaultValue={50} onChange={value => this.updateWgts(value)} />
            </div>
            <div className='asof'>As of {leftFund.asOfDate}</div>
            <div className='values'>
              <div className='value-ytw value'>
                <div className='value-num'>
                  Yield to Worst
                  <FontAwesomeIcon style={{ marginLeft: '2px', marginBottom: '8px', cursor: 'pointer' }} data-tip data-for={'yield'} icon='question-circle' size='xs' />
                  <br />
                  {ytw}%
                </div>
                <ReactTooltip id='yield' type='light' className='deftooltip' effect='float'>
                  <div>Yield to worst: The rate of return generated assuming a bond is redeemed by the issuer on the least desirable date for the investor.</div>
                </ReactTooltip>
                <div className='value-agg'>{ytwVS}% versus Agg</div>
              </div>
              <div className='value-sec value'>
                <div className='value-num'>
                  30-Day SEC Yield
                  <br />
                  (Unsubsidized)
                  <br />
                  <div className='value-agg'>As of {this.getSecYieldAsOfDate(leftFund)}</div>
                  <br />
                  {leftFund.ticker}: {this.getSecYield(leftFund)}
                  <br />
                  {rightFund.ticker}: {this.getSecYield(rightFund)}
                </div>
              </div>
              <div className='value-duration value'>
                <div className='value-num'>
                  Duration
                  <FontAwesomeIcon style={{ marginLeft: '2px', marginBottom: '8px', cursor: 'pointer' }} data-tip data-for={'duration'} icon='question-circle' size='xs' />
                  <br />
                  {duration}
                </div>
                <ReactTooltip id='duration' type='light' className='deftooltip' effect='float'>
                  <div>Duration: A measure of a bond’s sensitivity to changes in interest rates. The weighted average accounts for the various durations of the bonds purchased as well as the proportion of the total government bond portfolio that they make up.</div>
                </ReactTooltip>
                <div className='value-agg'>{durationVS} versus Agg</div>
              </div>
            </div>
          </div>
          <div className='selection-buttons'>
            <div className='overview-button'>
              <button className={showTab === 'overview' ? 'active' : 'not-active'} onClick={this.handleChangeTable.bind(this, 'overview')}>
                OVERVIEW
              </button>
            </div>
            <div className='performance-button'>
              <button className={showTab === 'performance' ? 'active' : 'not-active'} onClick={this.handleChangeTable.bind(this, 'performance')}>
                PERFORMANCE
              </button>
            </div>
            <div className='details-button'>
              <button className={showTab === 'details' ? 'active' : 'not-active'} onClick={this.handleChangeTable.bind(this, 'details')}>
                FUND DETAILS
              </button>
            </div>
          </div>
          <div className='info-tables'>{infoTables}</div>
        </div>
      )
    } else {
      barbellOutput = (
        <div className='waiting'>
          <FontAwesomeIcon icon='circle-notch' size='3x' className='waiting-icon' spin />
        </div>
      )
    }

    return <div className='app'>{barbellOutput} </div>
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    fundData: getFundData(state),
    ytw: getYTW(state),
    duration: getDuration(state),
    ytwVS: getYTWVS(state),
    durationVS: getDurationVS(state),
    weights: getWeights(state),
    selectedFund: getSelectedFund(state),
    filteredFundData: getFilteredFundData(state),
    leftFund: getLeftFund(state),
    rightFund: getRightFund(state)
  }
}

export default connect(mapStateToProps, {
  loadData,
  updateWeights,
  setSelectedFundSide
})(App)
